import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedCoutureRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-brand-paper text-gray-500" data-testid="couture-auth-loading">
                Chargement…
            </div>
        );
    }
    if (!user || user.role !== "couturier") {
        return <Navigate to="/couturier/login" replace state={{ from: location }} />;
    }
    return children;
}
